module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-08-18 at 11.55.11.16e40b79.png";